import axios from '../providers/axios';

export const PHONE_RESIDENTIAL = 1;
export const PHONE_COMMERCIAL = 2;
export const PHONE_MOBILE = 3;

export const getTypes = () => axios.get('/types/phones');
